export default {
  evidence_division: {
    id: "Id",
    code: "Mã",
    name: "Tên",
    description: "Mô tả",
    active: "Active",
    createdAt: "Tạo lúc",
    updatedAt: "Cập nhật lúc",
    create: "Tạo mới loại chứng cứ",
    update: "Cập nhật loại chứng cứ",
  }
}